 <template>
 <div class="user">
 <h1> {{ msg }} </h1>
 <div>
 <form accept-charset="UTF-8">
 <select v-model="type" @change="typesChanged">
 <option v-for="item in types" :key="item.type" :value="item.type"> 
{{ item.name }}
 </option>
 </select><br/>
 <label for="words">搜索词</label><input type="text" v-model="words" id="words" /><br/>
 <button @click="searchNow">搜索</button>
 <button @click="searchClean">清空</button>
 <label for="who">上传人ID</label><input type="text" v-model="who" id="who" /><br/>
 <button @click="queryNow">查询</button>
 <button @click="queryClean">清空</button>
 </form>
 </div>
 <div>
 目前匹配到书籍： {{ total }} 本。
 </div>
 <div id="book">
 <table>
 <thead>
 <tr>
 <th> ID </th>
 <th> 名称 </th>
 <th> 分类 </th>
 <th> 作者 </th>
 <th> 封面 </th>
 <th> 介绍 </th>
 <th> 出版商 </th>
 <th> 字数 </th>
 <th> 操作 </th>
 </tr>
 </thead>
 <tbody>
 <tr v-for="(item, index) in books" :key = "item.id">
 <td><h5>{{ item.id }}</h5></td>
 <td><input type="text" v-model="item.name"></td>
 <td><select v-model="item.type"><option v-for="it in types" :key="it.type" :value="it.type">{{ it.name }}</option></select></td>
 <td><input type="text" v-model="item.author"></td>
 <td><input type="text" v-model="item.cover"></td>
 <td><input type="text" v-model="item.description"></td>
 <td><input type="text" v-model="item.publish"></td>
 <td><input type="number" v-model="item.word_count"></td>
 <td>
 <button @click="bookEdit(index)">编辑</button>
 <button @click="bookDelete(index)">删除</button>
 </td>
 </tr>
 </tbody>
 </table>
 </div>

 <a v-if="moreBtn" href="javascript:void(0);" v-on:click="loadMore">加载更多</a>
 <span v-else="moreBtn">全部加载完毕</span>
 </div>
 </template>

 <script>
 import axios from "axios"
 export default {
 name: 'Book',
 data() {
 return {
 msg: '书籍管理',
 total: 0,
 moreBtn: false,
 isLogin: false,
 words: '',
 type: '', // 分类
 types: [],
 who: -1, // 查询谁的书籍，默认-1所有，0所有公共，大于0某个人的书籍
 lastId: 0,
 books: [],
 }
 }, // data()
 mounted() {
 if (sessionStorage.getItem("account") && sessionStorage.getItem("token")) {
 this.isLogin = true;
 this.uid = sessionStorage.getItem("uid")
 this.token = sessionStorage.getItem("token")
 this.nickname = sessionStorage.getItem("nickname")
 try {
 let uid = this.$route.query.uploaderUid
 if(typeof(uid)==="string") {
 uid = parseInt(uid);
 if(typeof(uid)==="number" && !isNaN(uid) && uid>0) {
 this.who = uid
 }
 }
 this.amount = parseInt(sessionStorage.getItem("amount"));
 } catch (e) {}
 this.typ = sessionStorage.getItem("typ");
 // 最后去抓取数据
 this.loadBookTypes()
 this.loadBooksData()
 }
 }, // mounted
 methods: {
 loadBookTypes() {
 const query = {
 uid: this.uid,
 access_token: this.token,
 time: (new Date().getTime() / 1000),
 };
 query.sig = this.checkSig(query)
 const params = [];
 for (const key in query) {
 params.push(`${key}=${query[key]}`);
 }
 axios.get(`${this.WEBCONF.url}books/types?${params.join('&')}`)
 .then(response => {
 if (response.status == 200) {
 if (response.data.code == 0) {
 this.types = response.data.data
 } else {
 alert(response.data.reason);
 }
 }
 }).catch(err => {
 alert("网络错误。");
 })

 }, // loadBookTypes
 loadBooksData() {
						const query = {
 uid: this.uid,
 access_token: this.token,
 lastId: this.lastId,
 search: this.words,
 type: this.type,
 who: this.who,
 time: (new Date().getTime() / 1000),
 };
 query.sig = this.checkSig(query)
 query.search = encodeURIComponent(query.search)
 const params = [];
 for (const key in query) {
 params.push(`${key}=${query[key]}`);
 }
 axios.get(`${this.WEBCONF.url}admin/books?${params.join('&')}`)
 .then(response => {
 if (response.status == 200) {
 if (response.data.code == 0) {
 this.total = response.data.data.total
 for (const it of response.data.data.items) {
 this.books.push(it);
 this.lastId = it.id;
 } // for
 this.moreBtn = this.books.length <this.total
 } else {
 alert(response.data.reason);
 }
 }
 }).catch(err => {
 alert("网络错误。");
 })
 }, // loadBooksData
 loadMore() {
 this.loadBooksData();
 }, // loadMore
 bookEdit(index) {
						const book = this.books[index]
 if (!book) {
 return;
 }
 const time = (new Date().getTime() / 1000);
const formData = {
uid: this.uid,
 access_token: this.token,
time: time,
name: book.name,
type: book.type,
author: book.author,
publish: book.publish || '',
cover: book.cover || '',
word_count: book.word_count,
description: book.description || '',
}
const sig = this.checkSig(formData)
console.log('sig2:', sig)
// 删掉重复的内容
delete formData.uid
delete formData.access_token
delete formData.time
                axios.post(`${this.WEBCONF.url}admin/books/${book.id}/update?uid=${this.uid}&access_token=${this.token}&time=${time}&sig=${sig}`, formData, {
                'Content-Type': 'application/json'
                })
    .then(response => {
        if(response.status==200) {
                    if(response.data.code==0) {
                    alert('编辑成功。');
                                                } else {
            alert(response.data.reason);
    }
    }
    }).catch(err => {
    alert("网络错误。");
    })
 
						}, // bookEdit
 bookDelete(index) {
 const book = this.books[index]
 if (!book) {
 return;
 }
					if(!confirm(`确认要删除： ${book.name}，删除后无法恢复。`)) {
						return;
					}
					const query = {
 uid: this.uid,
 access_token: this.token,
 time: (new Date().getTime() / 1000),
 };
 query.sig = this.checkSig(query)
 const params = [];
 for (const key in query) {
 params.push(`${key}=${query[key]}`);
 }
 axios.get(`${this.WEBCONF.url}admin/books/${book.id}/destroy?${params.join('&')}`)
 .then(response => {
 if (response.status == 200) {
 if (response.data.code == 0) {
 this.books.splice(index,1)
 alert(`成功删除书籍${book.name}`);
  } else {
 alert(response.data.reason);
 }
 }
 }).catch(err => {
 alert("网络错误。");
 })
					}, // bookDelete
 searchNow() {
 this.lastId = 0
 this.books = [];
 this.loadBooksData()
 }, // searchNow
 searchClean() {
 if (this.words == '') {
 return;
 }
 this.lastId = 0
 this.words = '';
 this.books = [];
 this.loadBooksData()
 }, // searchClean
 queryNow() {
 if(this.who==-1) {
 return;
 }
 this.lastId = 0
 this.words = '';
 this.books = [];
 this.type = '';
 this.loadBooksData()
 }, // queryNow
 queryClean() {
 if (this.who == -1) {
 return;
 }
 this.lastId = 0
 this.who = -1;
 this.words = '';
 this.type = '';
 this.books = [];
 this.loadBooksData()
 }, // queryClean
 typesChanged() {
 this.lastId = 0
 this.words = ''
 this.books = []
 this.loadBooksData()
 }, // typesChanged
 }, // methods
 }
 </script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Book.vue